import clsx from 'clsx';
import React from 'react';
import ProductTab from '../../Types/ProductTab';

interface ProductPageTabsProps {
  setActiveTab: (index: number) => void;
  tabs: ProductTab[];
  activeTabIndex: number;
}

const ProductPageTabsMenu = ({
  setActiveTab,
  tabs,
  activeTabIndex,
}: ProductPageTabsProps) => {
  return (
    <div className="hidden gap-6 lg:flex">
      {tabs.map((tab, idx) => (
        <button
          className={clsx(
            activeTabIndex == idx && '!text-gray-700 after:opacity-100',
            'lg:h4 xl:h3 relative text-start leading-normal !text-gray-300 after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:bg-gray-700 after:opacity-0 after:transition-opacity after:duration-500 hover:after:opacity-100'
          )}
          onClick={() => setActiveTab(idx)}
          key={tab.title + idx}
        >
          {tab.title}
        </button>
      ))}
    </div>
  );
};

export default ProductPageTabsMenu;
